import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appHideIfEmbedModeIsSet]'
})
export class HideIfEmbedModeIsSet {
  hasView = false;

  constructor(private readonly templateRef: TemplateRef<any>, private readonly viewContainer: ViewContainerRef) {
    const embedMode = !!localStorage.getItem('x-embed-mode');

    if (!embedMode) {
      if (!this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
      this.hasView = true;
    } else {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/hide-if-embed-mode-is-set.directive.ts